import { Component } from '@angular/core';

@Component({
  selector: 'close-x',
  standalone: false,
  template: `X`,
  styles: [`
  :host {
    font-family: Booton;
    color: var(--green-800);
    font-size: 20px;
    font-weight: 300;
    cursor: pointer;
  }
`]
})
export class CloseXComponent {}